<template>
    <div>
        <data-loader
            v-if="isLoading"
            message="Generating table data..."
        ></data-loader>

        <div v-if="isLoading == 0">
            <div>
                <h4>
                    {{ pageTitle }}
                </h4>

                <div
                    class="grid grid-cols-2 gap-4"
                    v-if="
                        filter.index.length > 0 &&
                        filter.shape.length > 0 &&
                        filter.jurisdiction.length > 0
                    "
                >
                    <div class="col-span-2 lg:col-span-1">
                        <h5 class="capitalize">
                            {{
                                indexTitle +
                                ", " +
                                jewelOptions.shape.options[filter.shape].title +
                                ", " +
                                (filter.jurisdiction ==
                                jewelOptions.jurisdiction.all_option.key
                                    ? jewelOptions.jurisdiction.all_option.title
                                    : jewelOptions.jurisdiction.options[
                                          filter.jurisdiction
                                      ].title) +
                                " Per Carat (USD)"
                            }}
                        </h5>
                        <div
                            class="my-2 text-xs"
                            v-if="valuationIndexTable.publish_date"
                        >
                            <span class="font-bold;">Publish Date:</span>
                            {{ valuationIndexTable.publish_date }}
                        </div>
                    </div>
                    <div
                        class="col-span-2 lg:col-span-1 text-right hidden lg:block"
                        v-if="valuationIndexTable.pdf_url"
                    >
                        <a
                            :href="valuationIndexTable.pdf_url"
                            target="_blank"
                            class="btn tertiary btn-download capitalize"
                            >Download Price List<i class="fal fa-download"></i
                        ></a>
                    </div>
                </div>
                <notice
                    v-if="
                        filter.index == 'auction' &&
                        !isEmpty(valuationIndexTable.result)
                    "
                    notice-type="info"
                    >Auction market pricing data is only available for 1.00ct
                    and over.</notice
                >
                <div
                    :class="
                        'grid grid cols-' +
                        filter_grid +
                        ' sm:grid-cols-' +
                        filter_grid * 2 +
                        ' gap-2 lg:gap-4 my-2 lg:my-4'
                    "
                >
                    <div :class="'col-span-' + filter_grid * 2 + ' text-sm'">
                        Select the price &amp; shape you wish to view per carat.
                    </div>
                    <div :class="'col-span-' + filter_grid + ' sm:col-span-2'">
                        <div class="form-item select-single">
                            <div class="hidden lg:flex">
                                <label>Price List: </label>
                                <Tooltip
                                    tooltip="Select the price list data you wish to view"
                                ></Tooltip>
                            </div>
                            <select
                                v-model="filter.index"
                                class="form-select single"
                                @change="getvaluationIndexTable()"
                            >
                                <option value="">-- Price List --</option>
                                <option value="auction">
                                    Your Auction Market Price List
                                </option>
                                <option value="wholesale">
                                    Your Wholesale Price List
                                </option>
                            </select>
                        </div>
                    </div>
                    <div :class="'col-span-' + filter_grid + ' sm:col-span-2'">
                        <div class="form-item select-single">
                            <div class="hidden lg:flex">
                                <label>{{ jewelOptions.shape.label }}: </label>
                                <Tooltip
                                    v-if="getHelpText('shape')"
                                    :tooltip="getHelpText('shape')"
                                ></Tooltip>
                            </div>
                            <select
                                v-model="filter.shape"
                                name="shape"
                                class="form-select single"
                                @change="getvaluationIndexTable()"
                            >
                                <option value="">
                                    -- {{ jewelOptions.shape.label }} --
                                </option>
                                <option
                                    v-for="(option, index) in jewelOptions.shape
                                        .options"
                                    :value="index"
                                >
                                    {{ option.title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div :class="'col-span-' + filter_grid + ' sm:col-span-2'">
                        <div class="form-item select-single">
                            <div class="hidden lg:flex">
                                <label
                                    >{{ jewelOptions.jurisdiction.label }}:
                                </label>
                                <Tooltip
                                    v-if="getHelpText('jurisdiction')"
                                    :tooltip="getHelpText('jurisdiction')"
                                ></Tooltip>
                            </div>
                            <select
                                v-model="filter.jurisdiction"
                                name="jurisdiction"
                                class="form-select single"
                                @change="getvaluationIndexTable()"
                            >
                                <option value="">
                                    -- {{ jewelOptions.jurisdiction.label }} --
                                </option>
                                <option
                                    :value="
                                        jewelOptions.jurisdiction.all_option.key
                                    "
                                >
                                    {{
                                        jewelOptions.jurisdiction.all_option
                                            .title
                                    }}
                                </option>
                                <option
                                    v-for="(option, index) in jewelOptions
                                        .jurisdiction.options"
                                    :value="index"
                                    v-if="option[filter.index]"
                                >
                                    {{ option.title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div
                        :class="'col-span-' + filter_grid + ' sm:col-span-2'"
                        v-if="caratRangeOptions.length > 0 && isMobile"
                    >
                        <div class="form-item select-single">
                            <div class="hidden lg:flex">
                                <label>Carat Range: </label>
                            </div>
                            <select
                                v-model="filter.carat_range"
                                name="carat_range"
                                class="form-select single"
                            >
                                <option value="">-- Carat --</option>
                                <option
                                    c
                                    v-for="(option, index) in caratRangeOptions"
                                    :value="option"
                                >
                                    {{ option }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="valuation-table-container"
                class="std-table-wrapper compact relative overflow-x-auto overflow-y-auto"
                :style="tableHeight + ' width: 100%;'"
                v-if="!isEmpty(valuationIndexTable.result)"
            >
                <div
                    v-for="(
                        valuation_data, carat
                    ) in valuationIndexTable.result"
                    v-if="checkActiveCaratRange(carat)"
                >
                    <div class="text-sm font-bold py-2 px-4 hidden lg:block">
                        Carat Range: {{ carat }}
                    </div>
                    <table class="">
                        <thead>
                            <tr class="header-row">
                                <th>&nbsp;</th>

                                <th
                                    class="header-cell"
                                    v-for="(
                                        clarity_data, clarity
                                    ) in jewelOptions.clarity.options"
                                >
                                    {{ clarity }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(color_data, color) in jewelOptions.color
                                    .options"
                            >
                                <td class="header-cell">{{ color }}</td>

                                <td
                                    v-for="(
                                        clarity_data, clarity
                                    ) in jewelOptions.clarity.options"
                                >
                                    {{
                                        valuationIndexTable.result[carat][
                                            color
                                        ][clarity]
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
function initialState() {
    return {
        isLoading: 1,
        caratOpened: [],
        colorOpened: [],
        window: {
            width: 0,
            height: 0,
        },
        filter: {
            shape: "",
            index: "",
            jurisdiction: "",
            carat_range: "",
            publish_date: "",
            pdf_url: "",
        },
        valuationIndexTable: {},
    };
}

import { mapGetters } from "vuex";
import _find from "lodash/find";
import _pickBy from "lodash/pickBy";
import _isEmpty from "lodash/isEmpty";
export default {
    props: {
        source: {
            type: String,
            required: true,
            default: "",
        },
    },
    data() {
        return initialState();
    },
    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    mounted() {
        return this.$store.dispatch("fetchJewelOptions", []).then((res) => {
            this.isLoading = 0;
        });
    },
    methods: {
        isEmpty(data) {
            return _isEmpty(data);
        },
        getvaluationIndexTable() {
            if (
                this.filter.shape.length == 0 ||
                this.filter.index.length == 0 ||
                this.filter.jurisdiction.length == 0
            ) {
                return;
            }
            this.isLoading = 1;
            let tableData = _find(this.valuationIndexTables, {
                shape: this.filter.shape,
                index: this.filter.index,
                jurisdiction: this.filter.jurisdiction,
            });
            if (tableData) {
                //reload what we already have
                this.valuationIndexTable = tableData;
                this.setDefaultCaratRange();
                this.isLoading = 0;

                return;
            } else {
                return this.$store
                    .dispatch("fetchValuationIndexTable", {
                        shape: this.filter.shape,
                        index: this.filter.index,
                        jurisdiction: this.filter.jurisdiction,
                    })
                    .then((res) => {
                        //assign to the local data for display
                        let tableData = _find(this.valuationIndexTables, {
                            shape: this.filter.shape,
                            index: this.filter.index,
                            jurisdiction: this.filter.jurisdiction,
                        });

                        if (tableData.result)
                            this.valuationIndexTable = tableData;
                        this.setDefaultCaratRange();

                        this.isLoading = 0;
                    });
            }
        },
        getCount(obj) {
            return this.$fabHelper.getDatalength(obj);
        },
        setDefaultCaratRange() {
            if (
                this.filter.carat_range in this.valuationIndexTable.result ===
                false
            ) {
                this.filter.carat_range = Object.keys(
                    this.valuationIndexTable.result
                )[0];
            }
        },

        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        getHelpText(field) {
            let helpText = this.jewelOptions[field].helpText[this.source]
                ? this.jewelOptions[field].helpText[this.source].create
                : "";
            return helpText.length > 0 ? helpText : false;
        },
        checkActiveCaratRange(carat) {
            if (carat == this.filter.carat_range || !this.isMobile) {
                return true;
            } else {
                return false;
            }
        },
    },
    computed: {
        ...mapGetters(["jewelOptions", "valuationIndexTables"]),
        isMobile() {
            return this.window.width < 1024;
        },
        tableHeight() {
            if (this.isMobile) {
                var screenHeight = screen.height - 64;

                if (screenHeight > 640) {
                    var height = "height:50vh;";
                } else {
                    var height = "height:75vh;";
                }
                return height;
            } else {
                return "";
            }
        },
        tableWidth() {},
        filter_grid() {
            return this.isMobile ? 4 : 3;
        },
        pageTitle() {
            if (this.filter.index == "auction") {
                return "Your Auction Market Price List";
            } else if (this.filter.index == "wholesale") {
                return "Your Wholesale Price List";
            } else {
                return "Your Diamonds Price Lists";
            }
        },
        indexTitle() {
            if (this.filter.index == "auction") {
                return "Auction";
            } else if (this.filter.index == "wholesale") {
                return "Wholesale";
            } else {
                return "";
            }
        },

        caratRangeOptions() {
            if (this.valuationIndexTable.result) {
                let carat_ranges = Object.keys(this.valuationIndexTable.result);
                return carat_ranges;
            } else {
                return [];
            }
        },
    },
};
</script>

<style></style>
